module.exports = __webpack_public_path__ + "img/ExtensionOutlined.b2ea497d.svg";